export const fmt = string => {
  let formatted = Number(string).toLocaleString('es-CO');
  if (formatted.length === 4 && formatted.indexOf('.') === -1) {
    formatted = formatted.slice(0, 1) + '.' + formatted.slice(1);
  }
  return formatted;
};

export const deformatPercentage = string => string.replace(',', '.');
